//Lokální build NODE.JS
//http://localhost:3000

//Produkční build NODE.JS
//https://nhhotels.onrender.com

//http://carlo_iv.csgcontrols.cz
//https://kiosk.csgcontrols.cz
//https://rests.csgcontrols.cz

// Automatická detekce prostředí
// 1. REACT_APP_API_URL z .env má vždy prioritu (i na localhost)
// 2. Na localhost bez .env → lokální backend
// 3. Jinak produkční URL

const getApiPath = () => {
  let apiPath;

  // Priorita 1: REACT_APP_API_URL z .env (platí vždy, i při npm start na localhost)
  if (process.env.REACT_APP_API_URL) {
    apiPath = process.env.REACT_APP_API_URL;
    console.log('🌐 API Path: Using REACT_APP_API_URL from .env:', apiPath);
    return apiPath;
  }

  // Priorita 2: Běží na localhost → lokální backend (jen když .env není nastaveno)
  if (typeof window !== 'undefined') {
    const hostname = window.location.hostname;
    if (hostname === 'localhost' || hostname === '127.0.0.1' || hostname === '') {
      apiPath = 'http://localhost:3001';
      console.log('🌐 API Path: Localhost (no .env) → local backend:', apiPath);
      return apiPath;
    }
  }

  // Priorita 3: Development mode bez window
  if (process.env.NODE_ENV === 'development') {
    apiPath = 'http://localhost:3001';
    console.log('🌐 API Path: Development mode →', apiPath);
    return apiPath;
  }

  // Priorita 4: Výchozí produkční URL
  apiPath = 'https://kiosk.csgcontrols.cz';
  console.log('🌐 API Path: Using production URL:', apiPath);
  return apiPath;
};


export const path = getApiPath();

/** Base URL pro obrázky a assety (uploady) – stejný server jako API */
// Vždy použít stejný base jako API path, aby fungovalo i z /admin/
// Kiosk na TV (webOS): https stránka + http média z jiného zápisu = blokace videa.
// buildMediaUrlForStoredPath bere média z hostitele aktuální URL (dev / prod / libovolný odkaz), ne z jiné domény v .env.
export const assetsBaseUrl = path.replace(/\/$/, '') + '/';

/**
 * Cesta z DB (uploads/…) nebo už absolutní http(s) URL.
 * Výchozí: stejný origin jako okno prohlížeče → funguje na https://dev.csgcontrols.cz/… i na jakémkoli jiném odkazu
 * (stejný reverse proxy musí servovat /uploads na tom hostu).
 * Výjimka: localhost + API na jiném portu (CRA) → použije se `path` z .env.
 * Vynutit vždy API z .env: REACT_APP_MEDIA_USE_API_URL=true
 */
export const buildMediaUrlForStoredPath = (storedPath) => {
  const direct = String(storedPath || '').trim();
  if (!direct) return '';
  if (/^https?:\/\//i.test(direct)) return direct;
  const relNorm = direct.replace(/^\/+/, '').replace(/\\/g, '/');
  const baseFromEnv = path.replace(/\/$/, '');

  const forceApiBase = String(process.env.REACT_APP_MEDIA_USE_API_URL || '').toLowerCase() === 'true';

  const joinApi = () => {
    let joined = `${baseFromEnv}/${relNorm}`;
    if (typeof window !== 'undefined' && window.location.protocol === 'https:' && joined.startsWith('http://')) {
      joined = `https://${joined.slice(7)}`;
    }
    return joined;
  };

  if (typeof window !== 'undefined' && window.location?.origin && !forceApiBase) {
    const pageOrigin = window.location.origin;
    const pageHost = window.location.hostname || '';
    try {
      const apiOrigin = new URL(path.replace(/\/$/, '')).origin;
      const localhostDev =
        (pageHost === 'localhost' || pageHost === '127.0.0.1') && apiOrigin !== pageOrigin;
      if (localhostDev) {
        return joinApi();
      }
    } catch (_) {
      return `${pageOrigin}/${relNorm}`;
    }
    return `${pageOrigin}/${relNorm}`;
  }

  return joinApi();
};
